import { render } from "./FundsManagement.vue?vue&type=template&id=c4963488"
import script from "./FundsManagement.vue?vue&type=script&lang=js"
export * from "./FundsManagement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__